import { render, staticRenderFns } from "./EditDialogTherapyAdmin.vue?vue&type=template&id=9c2d3082&scoped=true"
import script from "./EditDialogTherapyAdmin.vue?vue&type=script&lang=ts"
export * from "./EditDialogTherapyAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2d3082",
  null
  
)

export default component.exports